module.exports = __webpack_public_path__ + "media/hph-24-12_powerhouse.c4d7e052.mp4";